/**
 * Scroll to a target when opening it, clicking on a button
 * @param{jQuery} element
 * @param{jQuery} target
 */
export default function (element, target) {
    const extraTopScapeWidthThreshold = 768;
    const topExtraSpace = window.innerWidth <= extraTopScapeWidthThreshold ? $('#stickDisplayPreview').outerHeight() : 0;

    const $topbar = $('.la-topbar').first();
    const $navbar = $('#desktopNavbarContainer');

    const SCROLL_DURATION = 500;
    const SCROLL_PADDING = 50;

    element.click(function (e) {
        if (! target.hasClass('show') && window.innerWidth <= 1280) {
            $('html, body').animate({
                scrollTop: element.offset().top
                    - (
                        $navbar.outerHeight()
                        + $topbar.outerHeight()
                        + SCROLL_PADDING
                        + topExtraSpace
                    )
            }, SCROLL_DURATION)
        }
    })
}
